/**
 * Created by tomere on 04/02/2017.
 */
import Model from '../Model';
import ArtifactBundleModel from './ArtifactBundleModel';
import {RELEASE_BUNDLE_CONSTANTS} from '../../../constants/releaseBundle.constants';

export default class ArtifactsModel extends Model {

    constructor(data, artifactory_base_url, total_number_of_artifacts) {
        super(data);
        if(data) {
            this.artifacts = data.map(artifact => {
                artifact.artifactory_base_url = artifactory_base_url;
                return new ArtifactBundleModel(artifact)
            });
            this.organaized_artifacts = this._organizeArtifacts(this.artifacts);
        }
        this.total_number_of_artifacts = total_number_of_artifacts;
        this.is_showing_partial_artifacts_model = this.total_number_of_artifacts
            && this.artifacts
            && this.artifacts.length
            && this.total_number_of_artifacts > this.artifacts.length;
    }

    _organizeArtifacts(artifacts) {
        // The only way to inject JFrogUIUtils here (since this is a regular class)
        let JFrogUIUtils = angular.element(document.body).injector().get('JFrogUIUtils');
        let groupedData = _.groupBy(artifacts, 'packageName');
        let versionArtifacts = Object.keys(groupedData).map(packageName => {
            return {
                packageName: packageName,
                fileName: '',
                $subRows: _.filter(artifacts, artifact => artifact.packageName === packageName)
                        .map(subRow => {
                            subRow.packageName = '';
                            return subRow;
                        })
                        .sort((a, b) => JFrogUIUtils.sortData(a.fileName, b.fileName))
            };
        });
        let filesElement = _.find(versionArtifacts, x => x.packageName === RELEASE_BUNDLE_CONSTANTS.defaultPackageName);
        versionArtifacts = _.filter(versionArtifacts, x => x.packageName !== RELEASE_BUNDLE_CONSTANTS.defaultPackageName);
        if (filesElement) {
            versionArtifacts.push(filesElement);
        }
        return versionArtifacts;
    }

}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/ArtifactsModel.js